import { apiFetch } from "@/lib/api";

const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

function loadCheckout() {
  if (window.Razorpay) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = CHECKOUT_SRC;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Could not load the payment window. Check your connection."));
    document.body.appendChild(script);
  });
}

// Payment success is only trusted after the backend verifies it with Razorpay.
export async function startProCheckout(session, { onVerified, onMessage }) {
  const config = await apiFetch("/payments/config", null);
  if (!config.enabled) { onMessage("Pro payments are being set up. Please check back soon."); return; }
  await loadCheckout();
  const order = await apiFetch("/payments/order", session, { method: "POST" });
  const checkout = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "Studynexia",
    description: `Pro pass · ${order.days} days`,
    prefill: { email: order.email || "" },
    theme: { color: "#4d50d8" },
    handler: async (response) => {
      onMessage("Confirming your payment…");
      try {
        const result = await apiFetch("/payments/verify", session, { method: "POST", body: JSON.stringify(response) });
        onVerified(result);
      } catch (error) { onMessage(error.message); }
    },
    modal: { ondismiss: () => onMessage("") },
  });
  checkout.on("payment.failed", (event) => onMessage(event?.error?.description || "Payment failed. You have not been charged."));
  checkout.open();
}
